import React from 'react'

export default function Copyright() {
    return (
        <div className="text-muted">Copyright &copy; Foreks Bilgi İletişim Hizmetleri A.Ş.</div>
    )
}